<template>
  <div v-if="hasRole([consts.rolesText.ADMIN, consts.rolesText.ADMIN_ACADEMICO, consts.rolesText.COORDINADOR, consts.rolesText.DOCENTE,  consts.rolesText.ADMIN_RESTAURANTE, consts.rolesText.PSICOLOGO, consts.rolesText.GESTOR_ACADEMICO])">
    <div class="kit__utils__heading">
      <h5>
        <span class="mr-3">Gestión de observaciones</span>
      </h5>
    </div>
    <div class="card">
      <div class="card-body">
        <b-row>
          <b-col>
            <h5 class="mb-4">
              <strong>Lista de Observaciones</strong>
                <a-button v-if="hasPermission([consts.permissions.CREATE_OBSERVATIONS])" type="primary" shape="circle" icon="plus" class="float-right" @click = "createObservation()" />
            </h5>
          </b-col>
        </b-row>
        <b-form>
          <b-row>
            <b-col md="6" lg="4" xl="3">
              <b-form-group id="input-group-1" label="Identificacion:" label-for="input-1">
                <b-form-input id="input-1" v-model="formSearch.cc" placeholder="Ingrese el identificacion"></b-form-input>
              </b-form-group>
            </b-col>
            <b-col md="6" lg="4" xl="3">
              <b-form-group id="input-group-2" label="Nombre:" label-for="input-2">
                <b-form-input id="input-2" v-model="formSearch.name" placeholder="Ingrese el nombre"></b-form-input>
              </b-form-group>
            </b-col>
            <b-col md="6" lg="4" xl="3">
              <b-form-group id="input-group-3" label="Apellido:" label-for="input-3">
                <b-form-input id="input-3" v-model="formSearch.lastName" placeholder="Ingrese el apellido"></b-form-input>
              </b-form-group>
            </b-col>
            <b-col md="6" lg="3">
              <b-form-group id="input-group-4" label="Grado:" label-for="input-4">
                <b-form-select v-model="formSearch.grade" :options="grades"></b-form-select>
              </b-form-group>
            </b-col>
            <b-col md="6" lg="3">
              <b-form-group id="input-group-5" label="Tipo de observación:" label-for="input-5">
                <b-form-select v-model="formSearch.observationType" :options="observationType"></b-form-select>
              </b-form-group>
            </b-col>
            <b-col md="6" lg="3" v-if="hasRole([consts.rolesText.ADMIN, consts.rolesText.ADMIN_ACADEMICO, consts.rolesText.COORDINADOR]) && formSearch.observationType === consts.TYPE_OBSERVATION.TYPE_ATTENTION">
              <b-form-group id="input-group-6" label="Tipo de situación:" label-for="input-5">
                <b-form-select v-model="formSearch.situationType" :options="situationType"></b-form-select>
              </b-form-group>
            </b-col>
            <b-col md="6" lg="3" v-if="hasRole([consts.rolesText.ADMIN, consts.rolesText.ADMIN_ACADEMICO, consts.rolesText.COORDINADOR]) && formSearch.observationType === consts.TYPE_OBSERVATION.TYPE_ATTENTION && formSearch.situationType === consts.TYPE_OBSERVATION.SITUATION_I">
              <b-form-group id="input-group-7" label="Tipo de falta:" label-for="input-5">
                <b-form-select v-model="formSearch.fault" :options="faultType"></b-form-select>
              </b-form-group>
            </b-col>
            <b-col md="6" lg="3" v-if="user.role === consts.rolesText.DOCENTE && formSearch.observationType === consts.TYPE_OBSERVATION.TYPE_ATTENTION ">
              <b-form-group id="input-group-6" label="Tipo de falta:" label-for="input-5">
                <b-form-select v-model="formSearch.fault" :options="faultType"></b-form-select>
              </b-form-group>
            </b-col>
            <b-col md="6" lg="3" v-if="user.role !== consts.rolesText.DOCENTE">
              <b-form-group id="input-group-6" label="Año del observador:" label-for="input-6">
                <b-form-select  v-model="formSearch.idYear" :options="yearSchool"></b-form-select>
              </b-form-group>
            </b-col>
            <b-col md="6" lg="3" v-if="formSearch.observationType === consts.TYPE_OBSERVATION.TYPE_ATTENTION && formSearch.fault">
              <b-form-group id="input-group-7" label="Cantidad de faltas acumuladas:" label-for="input-7">
                <b-form-select  v-model="formSearch.countFault" :options="countFault"></b-form-select>
              </b-form-group>
            </b-col>
            <b-col md="6" lg="3">
              <b-form-group id="input-group-8" label="Ordenar por fecha:">
                <b-form-select v-model="formSearch.selectOrder" :options="orderOption"></b-form-select>
              </b-form-group>
            </b-col>
          </b-row>
        </b-form>
        <b-row>
          <b-col>
            <b-table v-if="observations.count !== 0" :items="observations.rows" :fields="columns" striped hover head-variant="light" responsive>
              <template #cell(actions)="observation">
                <div>
                  <a-tooltip placement="top" v-if="hasPermission([consts.permissions.READ_OBSERVATIONS])">
                    <template slot="title">
                      <span>Ver observacion</span>
                    </template>
                    <button type="button" @click="seeObservation(observation.item.id)" class="btn btn-light mr-2 col-md-1 col-xl-auto">
                      <i class="fa fa-eye" />
                    </button>
                  </a-tooltip>
                  <a-tooltip placement="top" v-if="hasPermission([consts.permissions.UPDATE_OBSERVATIONS]) && user.roles.some((role) => hierarchy(observation.item.roleCreator , observation.item.roleObserved, (role)))">
                    <template slot="title">
                      <span>Editar observacion</span>
                    </template>
                    <button type="button" @click="editObservation(observation.item.id)" class="btn btn-light mr-2 col-md-1 col-xl-auto">
                      <i class="fa fa-pencil" />
                    </button>
                  </a-tooltip>
                  <a-tooltip placement="top" v-if="hasPermission([consts.permissions.READ_OBSERVATIONS])"> <!--Consultar hoja de observacion del usuario-->
                    <template slot="title">
                      <span>Consultar historial de observaciones del usuario</span>
                    </template>
                    <button type="button" @click="consultObservationHistory(observation.item.idUser)" class="btn btn-light mr-2 col-md-1 col-xl-auto">
                      <i class="fa fa-book" />
                    </button>
                  </a-tooltip>
                  <a-tooltip placement="top" v-if="hasPermission([consts.permissions.DELETE_OBSERVATIONS]) && user.roles.some((role) => hierarchy(observation.item.roleCreator , observation.item.roleObserved, role))"> <!--Elminar-->
                    <template slot="title">
                      <span>Eliminar observación</span>
                    </template>
                    <button type="button" @click="deleteObservation(observation.item)" class="btn btn-light mr-2 col-md-1 col-xl-auto">
                      <i class="fa fa-times-circle text-red" />
                    </button>
                  </a-tooltip>
                </div>
              </template>
            </b-table>
            <empty-table v-else/>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <b-pagination
              v-model="pagination.currentPage"
              :total-rows="pagination.rows"
              :per-page="pagination.perPage"
              @input="search()"
              aria-controls="my-table"
            ></b-pagination>
          </b-col>
          <b-col class="text-right">
            {{ pagination.rows }} resultados
          </b-col>
        </b-row>
      </div>
    </div>
    <b-modal id="seeObservation" ref="modal" size="lg" hide-footer hide-header>
      <b-button pill variant="outline-transparent"  size="sm" class="float-right" @click="()=> { this.$bvModal.hide('seeObservation')}"><i class="fa fa-times" aria-hidden="true"></i></b-button>
      <observer @deleteObservationModal="deleteObservationModal" :observerUser="observationUser" :isHistory=true></observer>
      <div class="ml-3">
        <b-button size="sm" class="float-right ml-3" @click="()=> {this.$bvModal.hide('seeObservation')}">Cerrar</b-button>
      </div>
    </b-modal>
    <b-modal id="modal-search" hide-footer hide-header size="lg">
        <b-button pill variant="outline-transparent"  size="sm" class="float-right" @click="()=> {this.$bvModal.hide('modal-search')}"><i class="fa fa-times" aria-hidden="true"></i></b-button>
        <b-row class="m-3">
          <b-col>
            <userList @selectSU="selectSU" :properties="properties"/>
          </b-col>
        </b-row>
        <b-button size="sm" class="mr-2 d-block" @click="()=> {this.$bvModal.hide('modal-search')}">Cerrar</b-button>
    </b-modal>
  </div>
</template>

<script>
import emptyTable from '@/components/custom/cardEmptyList'
import apiClient2 from '@/services/axios/v2'
import { consts, hasRole, hasPermission, hierarchy, getRoleNameById, showErrorMessage } from '@/services/utilities'
import { mapState } from 'vuex'
import moment from 'moment'
import observer from '@/components/custom/observer'
import userList from '@/components/custom/userList'
import { ToastFire, SwalFire } from '@/services/utilities/swal'

export default {
  name: 'Observation',
  components: { emptyTable, observer, userList },
  data() {
    return {
      formSearch: {
        cc: '',
        name: '',
        lastName: '',
        grade: null,
        observationType: null,
        situationType: null,
        fault: null,
        countFault: null,
        idYear: null,
        selectOrder: 2,
      },
      grades: [],
      faultType: [],
      situationType: [
        { value: null, text: 'Seleccione tipo de situación' },
        { value: consts.TYPE_OBSERVATION.SITUATION_I, text: 'I' },
        { value: consts.TYPE_OBSERVATION.SITUATION_II, text: 'II' },
        { value: consts.TYPE_OBSERVATION.SITUATION_III, text: 'III' },
      ],
      observationType: [
        { value: null, text: 'Seleccione un tipo' },
        { value: consts.TYPE_OBSERVATION.TYPE_POSITIVE, text: 'Positiva' },
        { value: consts.TYPE_OBSERVATION.TYPE_ATTENTION, text: 'Llamado de atención' },
        { value: consts.TYPE_OBSERVATION.TYPE_FOLLOW_UP, text: 'Seguimiento' },
      ],
      countFault: [
        { value: null, text: 'Seleccione cantidad de faltas' },
        { value: 1, text: '1' },
        { value: 2, text: '2' },
        { value: 3, text: '3' },
        { value: 4, text: '4' },
        { value: 5, text: '5' },
        { value: 6, text: '6' },
        { value: 7, text: 'Mas de 6' },
      ],
      orderOption: [
        { value: 1, text: 'Ascendente ' },
        { value: 2, text: 'Descendente ' },
      ],
      columns: [
        { key: 'cc', label: 'Identificación' },
        { key: 'name', label: 'Nombre' },
        { key: 'lastName', label: 'Apellido' },
        { key: 'grade', label: 'Grado' },
        { key: 'observationType', label: 'Tipo de Observación' },
        { key: 'date', label: 'Fecha' },
        { key: 'actions', label: 'Acciones' },
      ],
      observations: {
        count: 0,
        rows: [],
      },
      pagination: {
        rows: 0,
        perPage: 10,
        currentPage: 1,
      },
      typingTimer: '',
      consts,
      observationUser: '',
      observationCreate: '',
      properties: {
        create: false,
        hasColumns: true,
        columns: {
          cc: true,
          balance: false,
          actions: true,
        },
        searchOptions: {
          cc: true,
          name: true,
          lastName: true,
          grade: false,
          codeCard: false,
        },
        hasActions: true,
        actions: {
          information: false,
          select: false,
          selectSU: true,
          rechargeBalance: false,
          rechargeCombos: false,
          startEnrollement: false,
        },
        user: {
          downloadEnrollmentSheet: false,
          deleteUser: false,
        },
        isObserved: true,
      },
      yearSchool: [],
    }
  },
  computed: {
    ...mapState(['user']),
  },
  watch: {
    'formSearch.cc': function () {
      this.formSearch.cc = this.formSearch.cc.trim()
      this.getByFields()
    },
    'formSearch.name': function () {
      this.formSearch.name = this.formSearch.name.trim()
      this.getByFields()
    },
    'formSearch.lastName': function () {
      this.formSearch.lastName = this.formSearch.lastName.trim()
      this.getByFields()
    },
    'formSearch.grade': function () {
      this.getByFields()
    },
    'formSearch.observationType': function () {
      if (this.formSearch.observationType !== consts.TYPE_OBSERVATION.TYPE_ATTENTION) {
        this.formSearch.situationType = null
        this.formSearch.fault = null
        this.formSearch.countFault = null
        this.getByFields()
      } else {
        this.getByFields()
      }
    },
    'formSearch.situationType': function () {
      if (this.formSearch.situationType !== consts.TYPE_OBSERVATION.SITUATION_I) {
        this.formSearch.fault = null
        this.formSearch.countFault = null
        this.getByFields()
      } else {
        this.getByFields()
      }
    },
    'formSearch.fault': function () {
      if (!this.formSearch.fault) {
        this.formSearch.countFault = null
      }
      this.getByFields()
    },
    'formSearch.countFault': function () {
      this.getByFields()
    },
    'formSearch.idYear': function () {
      this.getByFields()
    },
    'formSearch.selectOrder': function () {
      this.getByFields()
    },
  },
  created() {
    this.search()
    apiClient2.get('/grades', { params: this.formSearch }).then(response => {
      this.grades = response.data.data.map(grade => ({
        value: grade.id,
        text: grade.name,
      }))
      this.grades.unshift(({
        value: null,
        text: 'Seleccione el grado',
      }))
    }).catch(e => {
      ToastFire('warning', showErrorMessage(e))
    })
    this.years()
    apiClient2.get('/faults').then(response => {
      this.faultType = response.data.data.map(fault => ({
        value: fault.id,
        text: fault.name,
      }))
      this.faultType.unshift(({
        value: null,
        text: 'Seleccione la falta',
      }))
    }).catch(e => {
      ToastFire('warning', showErrorMessage(e))
    })
  },
  methods: {
    getByFields() {
      clearTimeout(this.typingTimer)
      this.typingTimer = setTimeout(() => { this.search() }, 500)
    },
    search() {
      this.formSearch.page = this.pagination.currentPage - 1
      this.formSearch.perPage = this.pagination.perPage
      apiClient2.get('/observations/', { params: this.formSearch }).then(response => {
        this.observations.count = response.data.data.count
        this.observations.rows = response.data.data.rows.map(row => ({
          id: row.id,
          idUser: row.observed.id,
          cc: row.observed.cc,
          name: (row.observed.firstName ? `${row.observed.firstName}` : '') + ' ' + (row.observed.secondName ? `${row.observed.secondName}` : ''),
          lastName: (row.observed.firstLastName ? `${row.observed.firstLastName}` : ' ') + ' ' + (row.observed.secondLastName ? `${row.observed.secondLastName}` : ''),
          grade: row.observed.currentGrade ? row.observed.currentGrade.name : 'N/A',
          observationType: row.observationType,
          date: moment(row.createdAt).format('YYYY-MM-DD hh:mm a'),
          roleCreator: row.creator.roles[0].id,
          roleObserved: row.observed.roles[0].id,
        }))
        this.pagination.rows = response.data.data.count
      }).catch(e => {
        ToastFire('warning', showErrorMessage(e))
      })
    },
    seeObservation(id) {
      apiClient2.get(`/observations/${id}`, { params: { idYear: this.formSearch.idYear } }).then(response => {
        this.observationUser = response.data.data
        this.$bvModal.show('seeObservation')
      }).catch(e => {
        ToastFire('warning', showErrorMessage(e))
      })
    },
    editObservation(id) {
      this.$router.push({ name: 'observationsEdit', params: { idObservation: id } })
    },
    consultObservationHistory(idUser) {
      this.$router.push({ name: 'observationsReport', params: { idUser: idUser, idYear: this.formSearch.idYear } })
    },
    async deleteObservation(observation) {
      const responseSwal = await SwalFire('Mensaje de confirmación', ('¿Desea remover la observación ' + observation.observationType + ' de ' + observation.name + ' ' + observation.lastName))
      if (responseSwal) {
        apiClient2.delete(`/observations/${observation.id}`).then(response => {
          this.observations.rows = this.observations.rows.filter((item) => { return item.id !== observation.id })
          ToastFire('success', 'Observacion eliminada correctamente')
        }).catch(error => {
          ToastFire('warning', showErrorMessage(error))
        })
      }
    },
    createObservation() {
      this.$bvModal.show('modal-search')
    },
    hasRole(roles) {
      return hasRole(roles, this.user.role)
    },
    selectSU(idUser) {
      this.$bvModal.hide('modal-search')
      this.$router.push({ name: 'observationsCreate', params: { userObserved: idUser } })
    },
    hasPermission(permissions) {
      return hasPermission(permissions, this.user.permissions)
    },
    deleteObservationModal(id) {
      this.observations.rows = this.observations.rows.filter((item) => { return item.id !== id })
    },
    years() {
      apiClient2.get('/years').then(response => {
        response.data.data.map((item) => {
          this.yearSchool.push({
            value: item.id,
            text: item.name,
          })
        })
        this.yearSchool.unshift(({
          value: null,
          text: 'Seleccione el año',
          disabled: true,
        }))
      }).catch(error => {
        ToastFire('warning', showErrorMessage(error))
      })
    },
    hierarchy(roleCreator, roleObserved, userRole) {
      return hierarchy(roleCreator, roleObserved, getRoleNameById(userRole))
    },
  },
}
</script>

<style></style>
